// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartLinesStyles } from "@bg/Overrides/Widgets/Cart/CartLines";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

cartLinesStyles.header!.saveOrderLink = {
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
            line-height: ${fontConfig.lineHeight.small};
        `,
    },
    icon: {
        iconProps: {
            src: "SystemUpdate",
            size: 16,
            color: "tertiary.main",
            css: css`
                svg {
                    fill: ${getColor("tertiary.main")};
                }
            `,
        },
    },
};
cartLinesStyles.header!.addAllToListLink = {
    css: css`
        margin-left: 30px;
        &&:hover svg path,
        &&:focus svg path {
            d: path(
                "M 14.65 0 C 12.72 0 11.02 0.87 10 2.19 C 8.98 0.87 7.28 0 5.35 0 C 2 0 0 2.87 0 5.65 c 0 6.31 9.11 11.67 9.5 11.9 l 0.5 0.29 l 0.5 -0.29 c 0.39 -0.23 9.5 -5.59 9.5 -11.9 C 20 2.48 17.65 0 14.65 0 Z M 10 5.06 L 10 5.06 L 10 5.06 L 10 5.06 Z"
            ) !important;
        }
    `,
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
            line-height: ${fontConfig.lineHeight.small};
        `,
    },
    icon: {
        iconProps: {
            src: "ProductListStroked",
            size: 16,
            color: "tertiary.main",
        },
    },
};
cartLinesStyles.header!.removeAllLink = {
    typographyProps: {
        css: css`
            color: ${getColor("text.main")} !important;
            line-height: ${fontConfig.lineHeight.small};
        `,
    },
    icon: {
        iconProps: {
            src: "Delete",
            size: 16,
            color: "tertiary.main",
        },
    },
};
